const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/

export function validateEmail(email: string): boolean {
  const trimmed = email.trim()

  return emailRegex.test(trimmed)
}
